<template>
  <b-form-group
    label="Hizmet Şekli"
    label-for="title"
  >
    <validation-provider
      #default="{ errors }"
      name="Hizmet Şekli"
      rules="required"
    >
      <b-form-input
        id="title"
        v-model="dataItem.title"
        placeholder="Hizmet Şekli"
      />
      <small class="text-danger">{{ errors[0] }}</small>
    </validation-provider>
  </b-form-group>
</template>

<script>
import { ValidationProvider, localize } from 'vee-validate'
import {
  BFormGroup, BFormInput,
} from 'bootstrap-vue'
import { required } from '@validations'

export default {
  name: 'NameText',
  components: {
    BFormGroup,
    BFormInput,
    ValidationProvider,
  },
  data() {
    return {
      required,
    }
  },
  computed: {
    dataItem() {
      return this.$store.getters['serviceTypes/dataItem']
    },
  },
  created() {
    localize('tr')
  },
}
</script>
